import { NavLink } from "react-router-dom";
import { cn } from "@/lib/utils";

// SectionTabs — v2.2.5 horizontal tab bar shared by the Discovery and
// System sections after the nav reorg (sidebar 12 → 8). Each tab is a
// react-router NavLink so deep links still work and `active` styling
// comes for free.
//
// Designed to render at the very top of a section's leaf page so the
// operator immediately sees the sibling pages within the group. The
// per-page `<h1>` and any filters render BELOW the tabs.
export interface SectionTab {
  to: string;
  label: string;
}

export function SectionTabs({
  tabs,
  title,
}: {
  tabs: SectionTab[];
  title?: string;
}) {
  return (
    <div className="border-b border-border bg-background">
      {title && (
        <div className="px-6 pt-4 text-xs font-medium uppercase tracking-wider text-muted-foreground">
          {title}
        </div>
      )}
      <nav className="flex items-center gap-1 px-4 pt-3">
        {tabs.map((t) => (
          <NavLink
            key={t.to}
            to={t.to}
            end
            className={({ isActive }) =>
              cn(
                "border-b-2 px-3 py-2 text-sm transition-colors",
                isActive
                  ? "border-primary text-foreground font-medium"
                  : "border-transparent text-muted-foreground hover:text-foreground hover:border-border",
              )
            }
          >
            {t.label}
          </NavLink>
        ))}
      </nav>
    </div>
  );
}

// Predefined tab sets — keep these here as the single source of truth so
// adding a tab is one location change, not "find every page that uses
// the bar and update each one".

export const DISCOVERY_TABS: SectionTab[] = [
  { to: "/discovery", label: "频道列表" },
  { to: "/keywords", label: "关键词管理" },
];

export const SYSTEM_TABS: SectionTab[] = [
  { to: "/system", label: "运行状态" },
  { to: "/audit", label: "审计日志" },
  { to: "/x-accounts", label: "X 账号" },
  { to: "/youtube-cookies", label: "YouTube Cookies" },
  { to: "/settings", label: "配置参考" },
];
